import * as React from 'react';
import Scrollbar from 'react-scrollbars-custom';
import styled from 'styled-components';

import scrollManagerStore from '../../stores/scroll';

const StyledScroll = styled.div`
  background: ${(props) => props.theme.main.colors.clay3} !important;
  width: 4px !important;
`;

const StyledTrack = styled.div`
  background: ${(props) => props.theme.main.colors.clay5} !important;
  width: 4px !important;
  padding: 8px 0;
`;

const StyledWrapper = styled.div`
  inset: 0 !important;
`;

type Props = {
  theme: 'light' | 'dark';
  children: React.ReactElement;
  loadMore?: Function;
  hasMore?: boolean;
  isYtrackVisible?: boolean;
  isXtrackVisible?: boolean;
  loader?: React.ReactNode;
  scrollBarClasses?: string;
  scrollDownCallBack?: Function;
};

type ScrollBarProps = {
  theme: 'light' | 'dark';
  children?: React.ReactElement;
  loader?: React.ReactNode;
};

export class CustomScrollBar extends React.PureComponent<Props> {
  static defaultProps = {
    theme: 'dark',
  };

  scrollRef: Scrollbar | null;

  componentDidMount() {
    scrollManagerStore.scrollRef = this.scrollRef!;
  }

  changeScrollStyle = (props: any) => {
    const { elementRef, ...restProps } = props;

    return <StyledScroll ref={elementRef} {...restProps} />;
  };

  changeTrackStyle = (props: any) => {
    const { elementRef, ...restProps } = props;
    return <StyledTrack ref={elementRef} {...restProps} />;
  };

  changeWrapperStyle = (props: any) => {
    const { elementRef, ...restProps } = props;
    return <StyledWrapper ref={elementRef} {...restProps} />;
  };

  handleUpdate = (container): void => {
    const { hasMore, loadMore, scrollDownCallBack } = this.props;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const bottomGutter = 150;
    // isBottom will be greater than 1 if we are about to reach the bottom
    const isBottom = (scrollTop + bottomGutter) / (scrollHeight - clientHeight) > 1;
    if (isBottom && hasMore && loadMore) {
      loadMore();
    }

    scrollDownCallBack && scrollDownCallBack(scrollTop);
  };

  destructScrollbarsProps = (): ScrollBarProps => {
    const scrollBarsProps = { ...this.props };
    // ScrollBar has warnings for unknown props
    delete scrollBarsProps.hasMore;
    delete scrollBarsProps.loadMore;
    delete scrollBarsProps.loader;

    return scrollBarsProps;
  };

  render() {
    const { isYtrackVisible = true, isXtrackVisible = true, children, hasMore, loader } = this.props;
    return (
      <Scrollbar
        trackYProps={{ style: { opacity: isYtrackVisible ? 1 : 0 }, renderer: this.changeTrackStyle }}
        trackXProps={{ style: { opacity: isXtrackVisible ? 1 : 0 }, renderer: this.changeTrackStyle }}
        thumbYProps={{ style: { opacity: isYtrackVisible ? 1 : 0 }, renderer: this.changeScrollStyle }}
        thumbXProps={{ style: { opacity: isXtrackVisible ? 1 : 0 }, renderer: this.changeScrollStyle }}
        wrapperProps={{ renderer: this.changeWrapperStyle }}
        ref={(ref) => (this.scrollRef = ref)}
        onScroll={this.handleUpdate}
      >
        {children}
        {hasMore && loader}
      </Scrollbar>
    );
  }
}
